module.exports = __webpack_public_path__ + "static/media/smelt.2eaac1c3.svg";